import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { sendToApp, addAppMessageListener } from "../../bridges/appBridge";
import SectionTitle from "../../assets/components/TitleGroup";
import alarm from "../../assets/icons/Permission/notification_subtle.svg";
import disk from "../../assets/icons/Permission/disk_subtle.svg";
import camera from "../../assets/icons/Permission/camera_subtle.svg";
import gallery from "../../assets/icons/Permission/photo_subtle.svg";
import { SingleButton } from "../../assets/components/ButtonGroup"
import { notifyWebLoadingDone } from "../../bridges/appBridge";

const AdsPermission = () => {
    const navigate = useNavigate();

    // ✅ 이 페이지가 화면에 뜬 순간, 앱 스플래시 종료
    useEffect(() => {
        notifyWebLoadingDone("AdsPermission");
        // 권한 페이지 진입 시에도 설치 ID / 푸시 토큰 재요청
        sendToApp("GET_INSTALLATION_ID", { source: "AdsPermission" });
        sendToApp("GET_PUSH_TOKEN", { source: "AdsPermission" });
    }, []);


    useEffect(() => {
        const off = addAppMessageListener((msg) => {
            const t = msg?.type;
            const p = msg?.payload || {};

            if (t === "INSTALLATION_ID" && p.install_id) {
                localStorage.setItem("install_id", p.install_id);
            }

            if (t === "PUSH_TOKEN" && p.token) {
                localStorage.setItem("platform", p.platform || "unknown");
                localStorage.setItem("device_token", p.token);
            }

            if (t === "PERMISSION_STATUS") {
                const { push } = p || {};
                const ok = push.granted
                // alert(localStorage.getItem("device_token"))

                if (!ok) {
                    alert("권한 비동의 시 업로드 예약 기능을 사용할 수 없습니다.")
                    // onExit();
                }

                const installId = localStorage.getItem("install_id");
                if (!installId) {
                    alert("설치 정보를 불러오지 못했습니다. 앱을 다시 실행하거나 잠시 후 다시 시도해 주세요.");
                    // 재요청 시도
                    sendToApp("GET_INSTALLATION_ID", { source: "AdsPermission", retry: Date.now() });
                    return;
                }

                const platform = (localStorage.getItem("platform") || "android").toLowerCase();

                axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/login/permission/confirm`,
                    {},
                    {
                        params: {
                            install_id: installId,
                            platform,
                        },
                        headers: { "Content-Type": "application/json" }
                    }
                ).then(() => {
                    navigate("/ads/register", { replace: true });
                }).catch((e) => {
                    console.error("permission confirm 실패", e);
                    alert("권한 확인에 실패했습니다. 앱 재설치 후 다시 시도해 주세요.");
                });
            }
        });

        return () => off?.();
    }, [navigate]);

    const onConfirm = () => {
        sendToApp("REQUEST_PERMISSION", { name: "push" });
    };

    const items = [
        { icon: alarm, t: "알림", d: "필수 알림과 마케팅 정보 안내" },
        { icon: disk, t: "저장공간", d: "이미지,미디어, 파일 저장 및 업로드" },
        { icon: camera, t: "카메라", d: "이미지 촬영 및 이미지 불러오기" },
        { icon: gallery, t: "사진 및 동영상", d: "촬영한 이미지 업로드 서비스" },
    ];


    return (
        <div>
            <SectionTitle
                className={"pt-[80px] px-[16px]"}
                title={"wizMarket 이용을 위해 \n 아래 권한 허용이 필요해요"}
                subTitle={"고객님께 나은 서비스를 제공하기 위해 사용됩니다. 허용하지 않으셔도 이용하실 수 있으나, 일부 서비스 이용이 제한될 수 있습니다."}
            />

            {/* 구분선 */}
            <div className="py-[28px]">
                <div className="bg-bg-white-subtle h-[16px]" />
            </div>


            <div className="space-y-[24px] px-[16px]">
                {items.map((item) => (
                    <div className="flex items-start gap-[16px]" key={item.t}>
                        <div className="bg-bg-white-subtle w-[48px] h-[48px] rounded-full flex items-center justify-center">
                            <img src={item.icon} alt={item.t} />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-t4 text-text-default pb-[2px]">{item.t}</div>
                            <ul className="text-b2 text-text-subtler">
                                <li >{item.d}</li>
                            </ul>
                        </div>
                    </div>
                ))}
            </div>

            <div className="fixed bottom-0 left-0 right-0 bg-surface-default">
                <SingleButton
                    id="auto-permission-btn"
                    onClick={onConfirm}
                >
                    확인
                </SingleButton>
            </div>
        </div>
    );
};

export default AdsPermission;
